import * as React from 'react';
const SvgEditIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg"  fill="none" {...props}>
    <path d="m20.533 7.34-2.79-2.74a2.06 2.06 0 0 0-2.708-.07l-9.164 9c-.33.326-.534.753-.58 1.21l-.439 4.17a.984.984 0 0 0 .296.8 1.02 1.02 0 0 0 .723.29h.091l4.246-.38c.465-.045.9-.247 1.232-.57l9.164-9a1.9 1.9 0 0 0 .535-1.37 1.904 1.904 0 0 0-.606-1.34ZM10.025 17.62l-3.055.28.275-3 5.753-5.58 2.75 2.7-5.723 5.6Zm7.046-6.94L14.342 8l1.986-2 2.78 2.73-2.037 1.95Z" />
  </svg>
);
export default SvgEditIcon;
